import { Button } from "@newsela/angelou";
import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";

import { modalFooterCss } from "./CitationGeneratorFooter.style";

const ButtonWithTrackEvent = withTrackEvent(Button);

interface CitationGeneratorFooterProps {
  handleDismiss: () => void;
}

const CitationGeneratorFooter = ({
  handleDismiss,
}: CitationGeneratorFooterProps) => {
  return (
    <div css={modalFooterCss}>
      <ButtonWithTrackEvent
        flavor={Button.flavors.primary}
        objectType={objectTypes.generatedTextAsset}
        actionName={actionNames.finish}
        onClick={handleDismiss}
        dataProps={{
          "data-qa-selector": "citation-done-button",
        }}
      >
        Done
      </ButtonWithTrackEvent>
    </div>
  );
};

export default CitationGeneratorFooter;
